import type { Unit } from '@/Units/types';

/**
 * Build a lookup map of unit ID → PMS unit name from the units array.
 * Only includes units that have a pms_config.unit_name set.
 */
export function buildUnitPmsNames(units: Unit[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const u of units) {
    if (u.pms_config?.unit_name) {
      map[u.id] = u.pms_config.unit_name;
    }
  }
  return map;
}

/**
 * Build a lookup map of unit ID → PMS unit_id (integer) from the units array.
 * Only includes units that have a pms_config.unit_id set.
 */
export function buildUnitPmsIds(units: Unit[]): Record<string, number> {
  const map: Record<string, number> = {};
  for (const u of units) {
    if (u.pms_config?.unit_id != null) {
      map[u.id] = u.pms_config.unit_id;
    }
  }
  return map;
}
